export default __webpack_public_path__ + "video-classificationbe04c4.png";